export default "__VITE_ASSET__LjPvaLLL__"